import React from "react";
import { Link } from "react-router-dom";
import { IMAGES } from "../constants/images";

const AboutUs = () => {
  return (
    <div
      style={{
        minHeight: "100dvh",
        background: "#327691",
        color: "#ffffff",
        fontFamily: "var(--zylen-font-family)",
      }}
    >
      <section className="px-4 py-16 md:py-24">
        <div className="mx-auto max-w-4xl">
          <div className="mb-10 flex items-center justify-between gap-4">
            <h1 className="text-2xl font-semibold lowercase md:text-3xl">about us</h1>
            <Link
              to="/"
              className="rounded-full border border-white/30 px-4 py-2 text-xs font-medium uppercase tracking-[0.12em] text-white no-underline transition hover:bg-white/10"
            >
              back to home
            </Link>
          </div>

          <div className="mb-10 overflow-hidden rounded-2xl border border-white/20">
            <img src={IMAGES.zylenIntro} alt="" className="h-52 w-full object-cover md:h-72" />
          </div>

          <div className="space-y-6 text-sm leading-[1.85] lowercase md:text-base">
            <p>
              at the beginning of 2025, joshua farrer directed his focus onto building a community online and
              creating a space where people could interact and learn from each other. beyond this, he envisioned a
              space that would allow him to sell his digital products to this community of individuals, helping
              them learn and grow within the filmmaking sphere.
            </p>
            <p>
              joshua embarked on this journey with a talented group of web designers who helped him design his
              first website, bringing his vision to life. during the building of joshua&apos;s website, web
              designer and good friend of joshua&apos;s, retief, suggested building an app for &apos;joshua
              farrer&apos;s&apos; community and digital products. loving this idea, joshua gave the go-ahead to
              start planning and developing this app.
            </p>
            <p>
              during the planning process, joshua realized the true potential this app held. not only for
              himself, but for all filmmakers, entrepreneurs and content creators in advancing their personal
              brands, communities and digital products.
            </p>
            <p>
              joshua recognized the truth that social media is no longer authentically &quot;social.&quot; he
              observed individuals spending their time &quot;doom-scrolling&quot; online, wasting away hours of
              their day, over actually meeting new people, forming genuine connections and learning from one
              another.
            </p>
            <p>this is where the idea of zylen was born.</p>
            <p>
              the name surfaced after a few weeks of brainstorming. joshua and his brother, michael, eventually came
              up with &quot;zylen.&quot; joshua wanted the name to be something new. something not overused.
              something that would grab people&apos;s attention. the name &quot;zylen&quot; has no specific meaning.
              however, joshua sought out to give it meaning.
            </p>
            <p>
              with the app zylen now built, joshua&apos;s vision is to bring the &apos;social&apos; back into
              &apos;social media,&apos; by assisting in the building of real communities, meeting like-minded
              people and selling digital products through the app.
            </p>
            <p>
              joshua wants this platform to bring you new opportunities. to help you make new friends. to allow the
              growth of your business. to assist you in learning and making money online. ultimately, his vision is
              that zylen would remind you to savor the &quot;now&quot; of life, by being intentional with those who
              are existing at the same time as you.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
